define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MWaterFacilityDomain = void 0;
    class MWaterFacilityDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MWaterFacilityDomain.BoreCapped, value: "Bore - capped" },
                    { key: MWaterFacilityDomain.BoreUncapped, value: "Bore - uncapped" },
                    { key: MWaterFacilityDomain.BoreDrain, value: "Bore - drain" },
                    { key: MWaterFacilityDomain.BoreSubArtesian, value: "Bore - sub-artesian" },
                    { key: MWaterFacilityDomain.Excavation, value: "Excavation" },
                    { key: MWaterFacilityDomain.Fluming, value: "Fluming" },
                    { key: MWaterFacilityDomain.PumpFuel, value: "Pump - fuel" },
                    { key: MWaterFacilityDomain.PumpElectric, value: "Pump - electric" },
                    { key: MWaterFacilityDomain.PumpSolar, value: "Pump - solar" },
                    { key: MWaterFacilityDomain.Spring, value: "Spring" },
                    { key: MWaterFacilityDomain.TankPoly, value: "Tank - poly" },
                    { key: MWaterFacilityDomain.TankConcrete, value: "Tank - concrete" },
                    { key: MWaterFacilityDomain.TankOther, value: "Tank - other" },
                    { key: MWaterFacilityDomain.TurkeyNest, value: "Turkey nest" },
                    { key: MWaterFacilityDomain.TroughConcrete, value: "Trough - concrete" },
                    { key: MWaterFacilityDomain.TroughSteel, value: "Trough - steel" },
                    { key: MWaterFacilityDomain.TroughOther, value: "Trough - other" },
                    { key: MWaterFacilityDomain.WaterHolePool, value: "Water hole/pool" },
                    { key: MWaterFacilityDomain.Well, value: "Well" },
                    { key: MWaterFacilityDomain.Wetland, value: "Wetland" },
                    { key: MWaterFacilityDomain.WindMill, value: "Wind mill" },
                    { key: MWaterFacilityDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MWaterFacilityDomain.BoreCapped] = 0;
                this.KeyIndex[MWaterFacilityDomain.BoreUncapped] = 1;
                this.KeyIndex[MWaterFacilityDomain.BoreDrain] = 2;
                this.KeyIndex[MWaterFacilityDomain.BoreSubArtesian] = 3;
                this.KeyIndex[MWaterFacilityDomain.Excavation] = 4;
                this.KeyIndex[MWaterFacilityDomain.Fluming] = 5;
                this.KeyIndex[MWaterFacilityDomain.PumpFuel] = 6;
                this.KeyIndex[MWaterFacilityDomain.PumpElectric] = 7;
                this.KeyIndex[MWaterFacilityDomain.PumpSolar] = 8;
                this.KeyIndex[MWaterFacilityDomain.Spring] = 9;
                this.KeyIndex[MWaterFacilityDomain.TankPoly] = 10;
                this.KeyIndex[MWaterFacilityDomain.TankConcrete] = 11;
                this.KeyIndex[MWaterFacilityDomain.TankOther] = 12;
                this.KeyIndex[MWaterFacilityDomain.TurkeyNest] = 13;
                this.KeyIndex[MWaterFacilityDomain.TroughConcrete] = 14;
                this.KeyIndex[MWaterFacilityDomain.TroughSteel] = 15;
                this.KeyIndex[MWaterFacilityDomain.TroughOther] = 16;
                this.KeyIndex[MWaterFacilityDomain.WaterHolePool] = 17;
                this.KeyIndex[MWaterFacilityDomain.Well] = 18;
                this.KeyIndex[MWaterFacilityDomain.Wetland] = 19;
                this.KeyIndex[MWaterFacilityDomain.WindMill] = 20;
                this.KeyIndex[MWaterFacilityDomain.Other] = 21;
                this.ValueIndex = {};
                this.ValueIndex["Bore - capped"] = 0;
                this.ValueIndex["Bore - uncapped"] = 1;
                this.ValueIndex["Bore - drain"] = 2;
                this.ValueIndex["Bore - sub-artesian"] = 3;
                this.ValueIndex["Excavation"] = 4;
                this.ValueIndex["Fluming"] = 5;
                this.ValueIndex["Pump - fuel"] = 6;
                this.ValueIndex["Pump - electric"] = 7;
                this.ValueIndex["Pump - solar"] = 8;
                this.ValueIndex["Spring"] = 9;
                this.ValueIndex["Tank - poly"] = 10;
                this.ValueIndex["Tank - concrete"] = 11;
                this.ValueIndex["Tank - other"] = 12;
                this.ValueIndex["Turkey nest"] = 13;
                this.ValueIndex["Trough - concrete"] = 14;
                this.ValueIndex["Trough - steel"] = 15;
                this.ValueIndex["Trough - other"] = 16;
                this.ValueIndex["Water hole/pool"] = 17;
                this.ValueIndex["Well"] = 18;
                this.ValueIndex["Wetland"] = 19;
                this.ValueIndex["Wind mill"] = 20;
                this.ValueIndex["Other"] = 21;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MWaterFacilityDomain = MWaterFacilityDomain;
    Object.defineProperty(MWaterFacilityDomain, "BoreCapped", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(MWaterFacilityDomain, "BoreUncapped", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MWaterFacilityDomain, "BoreDrain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MWaterFacilityDomain, "BoreSubArtesian", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MWaterFacilityDomain, "Excavation", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MWaterFacilityDomain, "Fluming", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MWaterFacilityDomain, "PumpFuel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MWaterFacilityDomain, "PumpElectric", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(MWaterFacilityDomain, "PumpSolar", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(MWaterFacilityDomain, "Spring", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(MWaterFacilityDomain, "TankPoly", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(MWaterFacilityDomain, "TankConcrete", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(MWaterFacilityDomain, "TankOther", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(MWaterFacilityDomain, "TurkeyNest", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 13
    });
    Object.defineProperty(MWaterFacilityDomain, "TroughConcrete", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(MWaterFacilityDomain, "TroughSteel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(MWaterFacilityDomain, "TroughOther", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 16
    });
    Object.defineProperty(MWaterFacilityDomain, "WaterHolePool", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 17
    });
    Object.defineProperty(MWaterFacilityDomain, "Well", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 18
    });
    Object.defineProperty(MWaterFacilityDomain, "Wetland", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 19
    });
    Object.defineProperty(MWaterFacilityDomain, "WindMill", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(MWaterFacilityDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 99
    });
    Object.defineProperty(MWaterFacilityDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
